import React from 'react';
import { Route } from 'react-router-dom';
import * as ROUTES from '../constants/routes';

import OrganizationShow from '../pages/organization/show';
import OrganizationEdit from '../pages/organization/edit';
import OrganizationCustomSettings from '../pages/organization/custom-settings';
import OrganizationUsers from '../pages/organization/users/index';
import OrganizationUsersNew from '../pages/organization/users/new';
import OrganizationUsersShow from '../pages/organization/users/show';
import OrganizationUsersEdit from '../pages/organization/users/edit';
import OrganizationUsersPermissionsShow from '../pages/organization/users/permissions/show';
import OrganizationUsersPermissionsNew from '../pages/organization/users/permissions/new';
import OrganizationUsersPermissionsEdit from '../pages/organization/users/permissions/edit';
import OrganizationEmployees from '../pages/organization/employees/index';
import OrganizationEmployeesEdit from '../pages/organization/employees/edit';
import OrganizationStakeholders from '../pages/organization/stakeholders/index';
import OrganizationStakeholdersNew from '../pages/organization/stakeholders/new';
import OrganizationCustomSettingsStatusesEdit from '../pages/organization/custom-settings/statuses/edit';
import OrganizationCustomSettingsCategoriesEdit from '../pages/organization/custom-settings/categories/edit';
import OrganizationCustomSettingsChangeImpactTypesEdit from '../pages/organization/custom-settings/change-impact-types/edit';
import OrganizationCustomSettingsOrganizationSettingsEdit from '../pages/organization/custom-settings/organization-settings/edit';
import OrganizationCustomSettingsChangeInsightsNew from '../pages/organization/custom-settings/change-insights/new';
import OrganizationCustomSettingsChangeInsightsEdit from '../pages/organization/custom-settings/change-insights/edit';
import OrganizationCustomSettingsChangeInsightsPreviewNew from '../pages/organization/custom-settings/change-insights/preview-new';
import OrganizationCustomSettingsChangeInsightsPreviewEdit from '../pages/organization/custom-settings/change-insights/preview-edit';

export const organizationRoutes = () => (
  <>
    <Route path={ROUTES.ORGANIZATION_SHOW} element={<OrganizationShow />} />
    <Route path={ROUTES.ORGANIZATION_EDIT} element={<OrganizationEdit />} />
    <Route
      path={ROUTES.ORGANIZATION_CUSTOM_SETTINGS}
      element={<OrganizationCustomSettings />}
    />

    {/* Custom Settings */}
    <Route
      path={ROUTES.ORGANIZATION_CUSTOM_SETTINGS_STATUSES_EDIT}
      element={<OrganizationCustomSettingsStatusesEdit />}
    />
    <Route
      path={ROUTES.ORGANIZATION_CUSTOM_SETTINGS_CATEGORIES_EDIT}
      element={<OrganizationCustomSettingsCategoriesEdit />}
    />
    <Route
      path={ROUTES.ORGANIZATION_CUSTOM_SETTINGS_CHANGE_IMPACT_TYPES_EDIT}
      element={<OrganizationCustomSettingsChangeImpactTypesEdit />}
    />
    <Route
      path={ROUTES.ORGANIZATION_CUSTOM_SETTINGS_ORGANIZATION_SETTINGS_EDIT}
      element={<OrganizationCustomSettingsOrganizationSettingsEdit />}
    />
    <Route
      path={ROUTES.ORGANIZATION_CUSTOM_SETTINGS_CHANGE_INSIGHTS_NEW}
      element={<OrganizationCustomSettingsChangeInsightsNew />}
    />
    <Route
      path={ROUTES.ORGANIZATION_CUSTOM_SETTINGS_CHANGE_INSIGHTS_EDIT}
      element={<OrganizationCustomSettingsChangeInsightsEdit />}
    />
    <Route
      path={ROUTES.ORGANIZATION_CUSTOM_SETTINGS_CHANGE_INSIGHTS_PREVIEW_NEW}
      element={<OrganizationCustomSettingsChangeInsightsPreviewNew />}
    />
    <Route
      path={ROUTES.ORGANIZATION_CUSTOM_SETTINGS_CHANGE_INSIGHTS_PREVIEW_EDIT}
      element={<OrganizationCustomSettingsChangeInsightsPreviewEdit />}
    />

    {/* Users */}
    <Route path={ROUTES.ORGANIZATION_USERS} element={<OrganizationUsers />} />
    <Route
      path={ROUTES.ORGANIZATION_USERS_NEW}
      element={<OrganizationUsersNew />}
    />
    <Route
      path={ROUTES.ORGANIZATION_USERS_SHOW}
      element={<OrganizationUsersShow />}
    />
    <Route
      path={ROUTES.ORGANIZATION_USERS_EDIT}
      element={<OrganizationUsersEdit />}
    />
    <Route
      path={ROUTES.ORGANIZATION_USERS_PERMISSIONS_SHOW}
      element={<OrganizationUsersPermissionsShow />}
    />
    <Route
      path={ROUTES.ORGANIZATION_USERS_PERMISSIONS_NEW}
      element={<OrganizationUsersPermissionsNew />}
    />
    <Route
      path={ROUTES.ORGANIZATION_USERS_PERMISSIONS_EDIT}
      element={<OrganizationUsersPermissionsEdit />}
    />

    {/* Employees */}
    <Route
      path={ROUTES.ORGANIZATION_EMPLOYEES}
      element={<OrganizationEmployees />}
    />
    <Route
      path={ROUTES.ORGANIZATION_EMPLOYEES_EDIT}
      element={<OrganizationEmployeesEdit />}
    />

    {/* Stakeholders */}
    <Route
      path={ROUTES.ORGANIZATION_STAKEHOLDERS}
      element={<OrganizationStakeholders />}
    />
    <Route
      path={ROUTES.ORGANIZATION_STAKEHOLDERS_NEW}
      element={<OrganizationStakeholdersNew />}
    />
  </>
);
